import AppStoreButton from './AppStoreButton';
import Reveal from './Reveal';
import './DownloadCTA.css';

export default function DownloadCTA() {
  return (
    <section className="cta section" id="download">
      <div className="container">
        <Reveal className="cta__card">
          <div className="cta__glow" aria-hidden="true" />
          <div className="cta__content">
            <h2 className="cta__title">Stop scrolling. Start watching.</h2>
            <p className="cta__sub">
              Find your next favorite movie or show with Peek, recommended by
              friends, family and Peekster.
            </p>
            <div className="cta__actions">
              <AppStoreButton variant="primary" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
